var min_width = 0, max_width = 0;
var optionsSpinner = {
            lines: 12,            // The number of lines to draw
            length: 5,            // The length of each line
            width: 2,             // The line thickness
            radius: 7,           // The radius of the inner circle
            rotate: 15,            // Rotation offset
            corners: 1,           // Roundness (0..1)
            color: 'rgba(128, 128, 128, .75)',        // #rgb or #rrggbb
            direction: 1,         // 1: clockwise, -1: counterclockwise
            speed: 1,             // Rounds per second
            trail: 100,           // Afterglow percentage
            opacity: 1/4,         // Opacity of the lines
            fps: 20,              // Frames per second when using setTimeout()
            zIndex: 1,          // Use a high z-index by default
            className: 'spinner-bf', // CSS class to assign to the element
            top: '50%',          // center vertically
            left: '50%',         // center horizontally
            position: 'absolute',
        };
function fotoramaInit(){
    //fotorama
    var $fotoramaDiv = $('.fotorama').fotorama();
    var fotorama = $fotoramaDiv.data('fotorama');
    $('.fotorama').on('fotorama:fullscreenenter fotorama:fullscreenexit', fotoramaFullscreen).fotorama();

//    $.each(data, function(index, value) {
//        if(value.length==0){
//            $('#'+index).addClass('inactive');
//        }else{
//            switch(index){
//                case 'all':
//                case 'before_after':
//                    $(document).on('click', '#'+index, function () {
//                        fotorama.destroy();
//                        $('.fotorama').on('fotorama:showend fotorama:ready fotorama:fullscreenenter fotorama:show fotorama:fullscreenexit', befAft).fotorama({
//                            data: data[index]
//                        });
//                        fotorama.show(0);
//                        setTimeout(function () {
//                            befAft();
//                        }, 100);
////                        resizeBA();
//                    });
//                    break;
//                case 'downloads':
//                    $(document).on('click', '#downloads', function () {
//                        fotorama.destroy();
//                        $('.fotorama').fotorama({
//                            data: data.downloads
//                        });
//                        fotorama.show(0);
//                        //Вставка списка загрузки изображений разного разрешения
//                        $('#fotorama').append(function () {
//                            return '<div class="my-select"><span><a class="my-selected-item" href="javascript:void(0);"><i class="fa fa-download fa-lg"></i>Download</a></span> <ul> <li><a href="javascript:void(0);">1366x768</a></li> <li><a href="javascript:void(0);">1920x1080</a></li> <li><a href="javascript:void(0);">1280x1024</a></li> <li><a href="javascript:void(0);">1024x768</a></li> <li><a href="javascript:void(0);">1280x800</a></li> <li><a href="javascript:void(0);">1680x1050</a></li> <li><a href="javascript:void(0);">1600x900</a></li> <li><a href="javascript:void(0);">1024x600</a></li> <li><a href="javascript:void(0);">1440x900</a></li> <li><a href="javascript:void(0);">1920x1200</a></li><li><a href="javascript:void(0);">2560x1600</a></li><li><a href="javascript:void(0);">2560x1440</a></li><li><a href="javascript:void(0);">2048x1536</a></li> </ul> </div>'
//                        });
//
//                        //кастомный select
//                        $('.my-select ul').slimscroll({
//                            width: '100%',
//                            height: '300px'
//                        });
//                    });
//                    break;
//                default:
//                        // если раскомментировать - баг на лендинге Гипнос
//                    // $(document).on('click', '#'+index, function () {
//                    //     fotorama.destroy();
//                    //     $('.fotorama').fotorama({
//                    //         data: data[index]
//                    //     });
//                    //     fotorama.show(0);
//                    // });
//                    break;
//            }
//        }
//    });

    if (!$('.fotorama').hasClass('fotorama-before')) {
        $('.fotorama').on('fotorama:showend fotorama:ready fotorama:fullscreenenter fotorama:show').fotorama();
    } else {
        $('.fotorama').on('fotorama:showend fotorama:ready fotorama:fullscreenenter fotorama:show', befAft).fotorama();
    }
   
    $(document).on('click', '.fotorama-filter a', function () {
        if($(this).hasClass('inactive')){
            return false;
        }else{
            $(this).addClass('active').siblings().removeClass('active');
        }
    });
}
function get_dimensions(src) {
    var img = new Image();
    img.src = src;
    var real_w = img.width;
    var real_h = img.height;
    //delete img;
    if(!real_h && !real_w){
        $(img).load(function(){        
            resizeBA(get_dimensions(src));
        });
    }    
    return {'real_width': real_w,
        'real_height': real_h,
        'ratio': real_w / real_h
    }
}
function befAft(e, fotorama) {    
    if(e && e.type=='fotorama:fullscreenenter'){
        $('.loaded').removeClass('loaded');
    }
    if(e && (e.type=='fotorama:show' || e.type=='fotorama:ready') ){
        // change bf img
        var isFullScreen = $('.type-Before-After #fotorama').hasClass('fotorama--fullscreen');
        var img = $(fotorama.activeFrame.html).find('.black_white img');
        var path = isFullScreen ? img.data('full'): img.data('fullb');        
        img.attr('src', path);
        
        var spinner = new Spinner(optionsSpinner).spin();
//        $(fotorama.activeFrame.html).find('.black_white').prepend(spinner.el);
    }
    if(e && e.type=='fotorama:show'){
        var $spinner = $(fotorama.activeFrame.$stageFrame[0]);        
        if(!$spinner.hasClass('loaded')){
            $spinner.addClass('spinner');
        }
    }else if(e && e.type=='fotorama:showend'){  
       $(fotorama.activeFrame.$stageFrame[0]).removeClass('spinner').addClass('loaded');
    }    
    var $black_white = $('.black_white'),
//            img_width = $('.black_white img').width(),
            img_width = $('.fotorama-before').width(),
            init_split = Math.round(img_width / 2);
    $black_white.width(init_split);
    $('.ba-circle').css('left', init_split - 26);

    if (device.desktop()) {        
        $('.before_after_slider').mousemove(function (e) {
            var offX = Math.round(e.clientX - ($(window).width() - $('.before_after_slider').width()) / 2) - 5;
            $black_white.width(offX);
            $('.ba-circle').css('left', offX - 26);
        });

        $('.before_after_slider').each(function (i, v) {
            v.addEventListener('touchmove', function (event) {
                var x = event.touches[0].pageX - (($(window).width() - $('.before_after_slider').width()) / 2);

                if (x < $('.before_after_slider').width() && x > 0) {
                    $black_white.width(x);
                    $('.ba-circle').css('left', x - 26);
                }
            }, false);
        });
    } else {    
        /*
        //change fotorama.js script
    function onStageTap (e, toggleControlsFLAG) {
    //console.time('onStageTap');    
        if (!device.desktop()) {
            var x = e.touches[0].pageX - $('.fotorama__stage').offset().left + e.view.scrollX;
            var $black_white = $('.black_white');
            if (x < $('.before_after_slider').width() && x > 0) {
                $black_white.animate({ width: x}, 500 );
                $('.ba-circle').animate({left:x - 26}, 500 );
            }
        }
        ....
        
         */
            
    }

    resizeBA();
}
function fotoramaFullscreen(e, fotorama, b){    
    if(e && e.type=='fotorama:fullscreenenter'){        
        fotorama.setOptions({nav:'none'});
        // $(window).trigger('gallery.fullscreen');
        // console.log('on');
        return;
    }
    if(e && e.type=='fotorama:fullscreenexit'){
        fotorama.setOptions({nav:'thumbs'});
        $('.fotorama__html').attr('style', '');
        // console.log('off');
        return;
    }
}


function resizeBA(img) {
    if (!img) {
//        var img = get_dimensions($('.fotorama__active .before_after_slider img').attr('src'));
        var img = get_dimensions($('.type-Before-After #fotorama .fotorama__active .fotorama__img').attr('src'));
    }
    var full = $('.type-Before-After .fotorama-before.fotorama--fullscreen');
    if(full.length!=0){
        var box = full;
    }else{
        var box = $('.type-Before-After .fotorama__stage');
    }
    
    img.box_width = box.width();
    img.box_height = box.height();
    if (img.box_height * img.ratio >= box.width()) {
        img.width = img.box_width;
        img.height = img.box_width / img.ratio;
    } else {
        img.width = img.box_height * img.ratio;
        img.height = img.box_height;
    }
    var marg = (img.box_width - img.width) / 2;
    marg = marg >= 0 ? marg : 0;
    img.height = img.height;
    $('.type-Before-After .fotorama__active .before_after_slider').css({height: img.height});
    $('.type-Before-After .fotorama__active .before_after_slider img').attr('style', '').css({height: img.height, 'margin-left': marg, 'margin-right': marg});

    var top = (img.box_height - img.height) / 2;
    top = top >= 0 ? top : 0;
    $('.type-Before-After .fotorama__active .fotorama__html').attr('style', '').css({top: top});
}